import { render, staticRenderFns } from "./BankMatchCampaignTip.vue?vue&type=template&id=463fd8c0&"
import script from "./BankMatchCampaignTip.vue?vue&type=script&lang=js&"
export * from "./BankMatchCampaignTip.vue?vue&type=script&lang=js&"
import style0 from "./BankMatchCampaignTip.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports